import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-bone px-4" data-testid="not-found-page">
      <div className="max-w-sm w-full text-center">
        <div className="w-20 h-20 rounded-full bg-navy/5 flex items-center justify-center mx-auto mb-5">
          <span className="text-gold text-3xl font-heading">404</span>
        </div>
        <h1 className="font-heading text-3xl text-navy mb-2">Page Not Found</h1>
        <p className="text-gray-500 text-sm mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-2.5 bg-gold text-navy rounded-full text-sm font-semibold hover:bg-gold/90 transition-colors"
          data-testid="not-found-home-link"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
